<main class="grid h-screen min-h-full items-center bg-white">
    @if(tiktokAccount) {



    <div class="relative sm:max-w-xl sm:mx-auto">
        <div
            class="absolute inset-0 custom-gradient transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl shadow-lg">
        </div>
        <div class="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">

            <div class="mx-auto w-full max-w-sm lg:w-96">

                <div class="flex items-center gap-x-6">
                    <img class="size-16 rounded-full" src="../../../assets/tiktok-middle.svg" alt="" />
                    <div>
                        <h3 class="text-2xl/9 font-bold tracking-tight text-gray-900">TikTok</h3>
                        <p class="text-sm/6 font-semibold text-fuchsia-600">Account Connected</p>
                    </div>
                </div>

                <div class="mt-10 flex flex-col gap-y-4 items-center justify-center">
                    <img class="mx-auto size-24 rounded-full" [src]="tiktokAccount.avatar_url" alt="" />
                    <h3 class="text-2xl/9 font-semibold tracking-tight text-gray-900">
                        {{tiktokAccount.display_name}}</h3>


                    <dl class="grid grid-cols-4 gap-0.5 overflow-hidden rounded-2xl text-center">
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Followers</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(tiktokAccount.follower_count)}}</dd>
                        </div>
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Following</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(tiktokAccount.following_count)}}</dd>
                        </div>
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Likes</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(tiktokAccount.likes_count)}}</dd>
                        </div>
                        <div class="flex flex-col bg-gray-400/5 p-4">
                            <dt class="text-sm/6 text-gray-600">Videos</dt>
                            <dd class="order-first text-xl font-semibold tracking-tight text-gray-900">{{
                                formatService.convertIntToString(tiktokAccount.video_count)}}</dd>
                        </div>
                    </dl>

                    <div class="w-full flex flex-row justify-between gap-x-4 items-center">

                        <button (click)="exitBrowser()" type="button" class="rounded bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Exit</button>

                        <button (click)="connectAnotherAccount()" type="button"
                            class="inline-flex items-center gap-x-1.5 rounded-md bg-fuchsia-600 px-2.5 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-fuchsia-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-fuchsia-600">
                            Connect Another Account
                            <svg class="-mr-0.5 size-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"
                                data-slot="icon">
                                <path fill-rule="evenodd"
                                    d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>

                </div>
            </div>

        </div>
    </div>


    } @else if (!connectionError && !tiktokAccount) {
    <div class="text-center">
        <svg aria-hidden="true" class="mx-auto w-16 h-16 text-gray-200 animate-spin dark:text-gray-600 fill-fuchsia-700"
            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor" />
            <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill" />
        </svg>

        <h3 class="mt-2 text-sm font-semibold text-gray-900">Loading...</h3>
        <p class="mt-1 text-sm text-gray-500">One moment please...</p>
    </div>
    } @else {
    <div class="text-center items-center">
        <h1>Error</h1>
        <p>Something went wrong</p>
        <p>{{connectionError}}</p>
    </div>
    }
</main>